import validation from './validation'

export default function validate(fieldName, value) {
  var validatejs = require("validate.js");

  var formValues = {}
  var formFields = {}

  formValues[fieldName] = value

  formFields[fieldName] = validation[fieldName]

  const result = validatejs(formValues, formFields)
 
  if (result) {
    return result[fieldName][0]
  }

  return null
}


// WEBPACK FOOTER //
// ./src/actions/validateWrapper.js